import React, { useReducer, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";
import _ from "lodash";
import tw from "tailwind-styled-components";
import IconButton from "@mui/material/IconButton";
import Skeleton from "@mui/material/Skeleton";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { FilterBox, ClubDetails } from "@containers";
import { WeatherView, PrimaryText } from "@components";
import {
  removeReduxTeeTime,
  showLoder,
  showCompleteLoder,
  activePlayer,
  updateDate,
  getListingBookings,
} from "@store";
import TeeTimeView from "../teeTimeBooking/widgets/teeTimeView";
import CartModal from "../teeTimeBooking/widgets/addToCartModal";

function TeeTimeBookingWithOutHeaderFooter() {
  const dispatch = useDispatch();
  const updatedDate = useSelector((state) => state.teeTime.date);
  const isLoading = useSelector((state) => state.teeTime.showLoder);
  const teeTimeApiSlugdata = useSelector(
    (state) => state.teeTime.teeTimeApiSlug
  );
  const addToCartData = useSelector((state) => state.bookings?.addToCartData);
  const teeTimeData = useSelector((state) => state.teeTime.teeTimeData);

  const [state, setState] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      activeDate: dayjs(),
      cartModal: false,
      cancelBookingModal: false,
      bookingId: null,
      data: [],
      pageNumber: 1,
      newTeeTime: [],
      callApi: false,
    }
  );

  useEffect(() => {
    if (updatedDate) {
      setState({ activeDate: updatedDate });
    } else {
      setState({ activeDate: dayjs(teeTimeApiSlugdata?.apiData?.bookingDate) });
    }
  }, [updatedDate, teeTimeApiSlugdata]);
  const selectedDate = dayjs(teeTimeApiSlugdata?.apiData?.bookingDate);
  const nextDate = dayjs(teeTimeApiSlugdata?.apiData?.bookingDate).add(
    1,
    "day"
  );
  const newDateAfterTomorrow = dayjs(
    teeTimeApiSlugdata?.apiData?.bookingDate
  ).add(2, "day");
  const newDateAfterTomorrow2 = dayjs(
    teeTimeApiSlugdata?.apiData?.bookingDate
  ).add(3, "day");

  useEffect(() => {
    if (teeTimeData?.success === true) {
      const unique = teeTimeData?.data?.teeTimeV2.filter((obj, index) => {
        return (
          index ===
          teeTimeData?.data?.teeTimeV2.findIndex(
            (o) =>
              obj?.id === o?.id &&
              obj?.course === o?.course &&
              o?.time === obj?.time
          )
        );
      });

      const currentTimeFilter = _.filter(unique, function (e) {
        if (dayjs(e.time).format("D") === dayjs().format("D")) {
          return dayjs(e.time).format("HHmm") > dayjs().format("HHmm");
        } else {
          return e;
        }
      });

      let groupWithCourse = currentTimeFilter.reduce(function (r, a) {
        r[a?.course] = r[a?.course] || [];
        r[a?.course].push(a);
        return r;
      }, Object.create(null));

      const sortWithCourseName = Object.keys(groupWithCourse)
        .sort()
        .reduce((obj, key) => {
          obj[key] = groupWithCourse[key];
          return obj;
        }, {});

      let allCourse = Object.values(sortWithCourseName);

      let timeFilter = [];
      allCourse?.map((item) => {
        let filterForMorning = _.filter(item, function (e) {
          return dayjs(e?.time).format("H") < 12;
        });
        let filterForEvening = _.filter(item, function (e) {
          return dayjs(e?.time).format("H") > 11;
        });
        let timeData = [
          {
            type: "Morning",
            courseName:
              filterForMorning.length > 0 ? filterForMorning[0].course : "",
            data: filterForMorning,
          },
          {
            type: "Afternoon",
            courseName:
              filterForEvening.length > 0 ? filterForEvening[0].course : "",
            data: filterForEvening,
          },
        ];
        timeFilter.push(timeData);
      });
      setState({ data: timeFilter });
    } else {
    }
  }, [teeTimeData]);

  const closeModal = () => {
    setState({ cartModal: false });
  };

  const ShowMessage = (props) => {
    return (
      <div className="w-full h-full flex justify-center items-center my-[20px]">
        <PrimaryText
          className={"center text-xl text-white255 animate-pulse text-center "}
        >
          {props.title}
        </PrimaryText>
      </div>
    );
  };

  const changeDate = (newDate) => {
    var apiData = {
      holes: teeTimeApiSlugdata?.apiData?.holes,
      players: teeTimeApiSlugdata?.apiData?.players,
      bookingDate: newDate,
      facilitiesId: teeTimeApiSlugdata?.apiData?.facilitiesId,
    };
    var bookingsApiData = {
      fromDate: dayjs(newDate).subtract(1, "day").format("DD-MM-YYYY"),
      toDate: dayjs(newDate).add(1, "day").format("DD-MM-YYYY"),
    };
    setState({ activeDate: dayjs(newDate) });
    dispatch(updateDate(newDate));
    dispatch(activePlayer(apiData.players));
    dispatch(showLoder(true));
    dispatch(removeReduxTeeTime());
    dispatch(showCompleteLoder(true));
    dispatch(getListingBookings(bookingsApiData));

    setState({ callApi: true, pageNumber: 1, newTeeTime: [] });
  };

  const DateView = (props) => {
    return (
      <DateBtn
        onClick={() => changeDate(props?.title)}
        className={`${
          dayjs(state.activeDate).format("DD-MM-YYYY") ===
          dayjs(props?.title).format("DD-MM-YYYY")
            ? "bg-navy hover:cursor-default"
            : "bg-black0a hover:opacity-70"
        }`}
      >
        <p className={`text-sm font-[Cambay] text-center text-white255`}>
          {dayjs(props?.title).format("ddd, D MMM")}
        </p>
      </DateBtn>
    );
  };

  const CartView = () => {
    return (
      <div
        className={`${
          addToCartData?.length < 1 ? "cursor-not-allowed" : "cursor-default"
        }`}
      >
        <div
          className={`w-full h-[42px] flex flex-row items-center justify-start rounded-full gap-x-2 p-[2px] bg-black0a ${
            addToCartData?.length > 0 ? "hover:cursor-pointer" : ""
          } `}
          onClick={() =>
            setState({ cartModal: addToCartData?.length > 0 ? true : false })
          }
        >
          <div>
            <IconButton
              disabled={addToCartData?.length > 0 ? false : true}
              sx={{ bgcolor: "#ffffff36" }}
            >
              {addToCartData?.length > 0 ? (
                <ShoppingCartIcon fontSize="medium" sx={{ color: "white" }} />
              ) : (
                <ShoppingCartIcon fontSize="medium" sx={{ color: "#858585" }} />
              )}
            </IconButton>
          </div>
          {addToCartData?.length > 0 && (
            <div className="h-full w-[80px] flex flex-col items-start justify-center overflow-hidden">
              <PrimaryText className="leading-4 text-white255 opacity-60 text-[13px]">
                {addToCartData?.length + " selected"}
              </PrimaryText>
              <PrimaryText className="leading-4 text-white255 font-medium text-[17px]">
                {"€ " + totalPrice}
              </PrimaryText>
            </div>
          )}
        </div>
        <CartModal openModal={state.cartModal} closeModal={closeModal} />
      </div>
    );
  };

  const SkeletonLoader = () => {
    const DateLoader = () => {
      return (
        <div className="w-[90px] h-[28px] rounded-md">
          <Skeleton
            variant="rounded"
            sx={{ bgcolor: "#00000054", borderRadius: "13px" }}
            width={90}
            height={28}
          />
        </div>
      );
    };
    const CartLoader = () => {
      return (
        <div className="w-[40px] h-[40px] rounded-full">
          <Skeleton
            variant="circular"
            sx={{ bgcolor: "#00000054" }}
            width={40}
            height={40}
          />
        </div>
      );
    };
    const TxtLoader = () => {
      return (
        <div className="w-[128px] h-[25px]">
          <Skeleton
            variant="text"
            sx={{ bgcolor: "#00000054" }}
            width={128}
            height={25}
          />
        </div>
      );
    };
    const BoxLoader = () => {
      return (
        <div className="w-[90px] h-[67px] rounded-lg">
          <Skeleton
            variant="rounded"
            sx={{ bgcolor: "#ffffff5c", borderRadius: "10px" }}
            animation="wave"
            width={90}
            height={67}
          />
        </div>
      );
    };

    return (
      <LoaderView>
        <AnimationDate>
          <div className="w-auto h-auto flex flex-wrap items-center justify-start gap-2 p-2 rounded-md">
            <DateLoader />
            <DateLoader />
            <DateLoader />
            <DateLoader />
          </div>
          <CartLoader />
        </AnimationDate>

        <AnimationTeeTime>
          <div className="w-full h-full flex flex-col items-center gap-2">
            <TxtLoader />
            <AnimatedBox>
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
            </AnimatedBox>
          </div>

          <div className="w-full h-full xl3:flex hidden flex-col items-center gap-2">
            <TxtLoader />
            <AnimatedBox>
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
              <BoxLoader />
            </AnimatedBox>
          </div>
        </AnimationTeeTime>
      </LoaderView>
    );
  };

  const prices =
    addToCartData.length > 0
      ? addToCartData.map((a) => a?.price?.publicRate?.amount)
      : "";
  const totalPrice =
    addToCartData.length > 0 ? prices.reduce((acc, curr) => acc + curr) : "";

  return (
    <div className={mainView}>
      <div className={teeTimeView}>
        <div className={courseView}>
          <FilterBox />
          <WeatherView />
        </div>
        <div className={teeTimeBookingView}>
          {isLoading ? (
            <SkeletonLoader />
          ) : !isLoading && teeTimeData?.success === true ? (
            !state.data?.length > 0 ? (
              <ShowMessage title="No Tee times available" />
            ) : (
              <Container>
                <div className="w-full h-full flex flex-row items-center justify-between">
                  <div className={dateView}>
                    <DateView title={selectedDate} />
                    <DateView title={nextDate} />
                    <DateView title={newDateAfterTomorrow} />
                    <DateView title={newDateAfterTomorrow2} />
                  </div>
                  {CartView()}
                </div>
                <TeeTimeView data={state.data} />
              </Container>
            )
          ) : (
            <ShowMessage title='To view tee times, select your preferred filters and click on the "REFRESH TEE TIMES" button' />
          )}
        </div>
        <div className={clubView}>
          <div className="w-full h-full flex xl:justify-end justify-center rounded-lg">
            <ClubDetails />
          </div>
        </div>
      </div>
    </div>
  );
}

const mainView = `
w-full 
h-auto
px-4
pt-4
flex
items-between
justify-center
lg2:flex-row
flex-col
`;
const teeTimeView = `
h-full
w-full
flex
xl:flex-row
flex-col
xl:items-start
items-center
justify-between
`;
const courseView = `
xl:w-[22%]
w-full
max-w-[360px] 
h-auto
md:flex
flex-col 
items-center
`;
const teeTimeBookingView = `
xl:w-[53%]
w-full 
h-auto
md2:my-0 
my:-[40px]
justify-center
items-center
`;
const clubView = `
h-auto
xl:w-[22%]
w-full
max-w-[360px]
md:flex
flex-row
items-between
justify-between
rounded-lg
`;
const Container = tw.div`
w-auto
h-auto
mx-[2px]
px-[2px]
mt-[6px]
mb-[33px]
`;
const dateView = `
w-full 
h-auto 
flex 
flex-wrap 
itmes-center
gap-2
`;
const DateBtn = tw.button`
sm:w-[100px]
sm2:w-[100px]
w-[90px] 
h-auto 
rounded-2xl 
flex 
items-center 
justify-center 
py-[4px]
`;
const LoaderView = tw.div`
w-full 
lg2:h-[530px] h-fit 
flex 
flex-col 
justify-center 
items-center 
gap-2 
rounded-lg 
p-2 
overflow-hidden
mb-8
`;
const AnimationDate = tw.div`
w-full 
h-auto 
flex 
flex-row 
items-center 
justify-between 
gap-x-2 
rounded-lg
`;
const AnimationTeeTime = tw.div`
flex 
flex-row 
items-center 
justify-around 
w-full 
h-full 
rounded-lg 
gap-2
`;
const AnimatedBox = tw.div`
w-full 
h-full 
flex 
flex-wrap 
items-center 
justify-center 
gap-2 
border-[1px]
border-white255 
rounded-2xl 
py-2
`;

export default TeeTimeBookingWithOutHeaderFooter;
